import { render, staticRenderFns } from "./TaskSessions.vue?vue&type=template&id=3790c378&"
import script from "./TaskSessions.vue?vue&type=script&lang=js&"
export * from "./TaskSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports